import { createAction, props } from '@ngrx/store';
import { ICP } from './icp.state';

// Load ICPs Actions
export const loadIcps = createAction(
  '[ICP] Load ICPs',
  props<{ 
    page?: number; 
    perPage?: number; 
    search?: string;
    filter?: { is_default?: boolean };
    include?: string[];
  }>()
);

export const loadIcpsSuccess = createAction(
  '[ICP] Load ICPs Success',
  props<{ icps: ICP[]; pagination: any }>()
);

export const loadIcpsFailure = createAction(
  '[ICP] Load ICPs Failure',
  props<{ error: any }>()
);

// Get ICP Detail Actions
export const getIcpDetail = createAction(
  '[ICP] Get ICP Detail',
  props<{ id: string }>()
);

export const getIcpDetailSuccess = createAction(
  '[ICP] Get ICP Detail Success',
  props<{ icp: ICP }>()
);

export const getIcpDetailFailure = createAction(
  '[ICP] Get ICP Detail Failure',
  props<{ error: any }>()
);

// Load ICP Detail Actions (legacy - keep for backward compatibility)
export const loadIcpDetail = createAction(
  '[ICP] Load ICP Detail',
  props<{ id: string }>()
);

export const loadIcpDetailSuccess = createAction(
  '[ICP] Load ICP Detail Success',
  props<{ icp: ICP }>()
);

export const loadIcpDetailFailure = createAction(
  '[ICP] Load ICP Detail Failure',
  props<{ error: any }>()
);

// Create ICP Actions
export const createIcp = createAction(
  '[ICP] Create ICP',
  props<{ icp: Partial<ICP> }>()
);

export const createIcpSuccess = createAction(
  '[ICP] Create ICP Success',
  props<{ icp: ICP }>()
);

export const createIcpFailure = createAction(
  '[ICP] Create ICP Failure',
  props<{ error: any }>()
);

// Update ICP Actions
export const updateIcp = createAction(
  '[ICP] Update ICP',
  props<{ id: number; icp: Partial<ICP> }>()
);

export const updateIcpSuccess = createAction(
  '[ICP] Update ICP Success',
  props<{ icp: ICP }>()
);

export const updateIcpFailure = createAction(
  '[ICP] Update ICP Failure',
  props<{ error: any }>()
);

// Delete ICP Actions
export const deleteIcp = createAction(
  '[ICP] Delete ICP',
  props<{ id: number }>()
);

export const deleteIcpSuccess = createAction(
  '[ICP] Delete ICP Success',
  props<{ id: number }>()
);

export const deleteIcpFailure = createAction(
  '[ICP] Delete ICP Failure',
  props<{ error: any }>()
);

// Clone ICP Actions
export const cloneIcp = createAction(
  '[ICP] Clone ICP',
  props<{ id: number; name?: string }>()
);

export const cloneIcpSuccess = createAction(
  '[ICP] Clone ICP Success',
  props<{ icp: ICP }>()
);

export const cloneIcpFailure = createAction(
  '[ICP] Clone ICP Failure',
  props<{ error: any }>()
);

// Reset Actions
export const resetCreateIcp = createAction(
  '[ICP] Reset Create ICP'
);

export const resetUpdateIcp = createAction(
  '[ICP] Reset Update ICP'
);

export const resetDeleteIcp = createAction(
  '[ICP] Reset Delete ICP'
);